module.exports = __webpack_public_path__ + "static/pt-serif-v12-latin-italic-0c4aa22c1666d8a60e42a1fad03b891a.woff2";